<template>
  <div v-frag class="prism-elite-app">
    <CardIeaAppMain colorCard="#0F172A" title="">
      <v-col cols="12" class="pa-0 main-container-glass">
        <!-- Top Bar -->
        <div class="prism-top-bar d-flex align-center justify-space-between px-8 py-5">
           <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({ name: 'Home' })"
              class="mr-4 glass-btn"
              large
              v-if="user && user.IDStB"
            >
              <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
             <div>
              <h1 class="text-h6 font-weight-black prism-title mb-0">Pagos y Trámites</h1>
              <div class="text-caption grey--text font-weight-medium">Gestión de Conceptos Regulares</div>
            </div>
           </div>
        </div>

        <v-divider class="prism-divider"></v-divider>

        <v-row class="pa-8">
          <!-- Selection Layer -->
          <v-col cols="12" class="mb-6">
             <v-card flat class="pa-8 rounded-xl glass-card-heavy">
                <v-row align="center">
                   <v-col cols="12" md="6">
                      <div class="d-flex align-center">
                        <div class="elite-icon-box mr-4">
                            <v-icon color="primary">mdi-map-marker-radius-outline</v-icon>
                        </div>
                        <div>
                            <h2 class="text-h6 font-weight-black prism-heading">Sede del Trámite</h2>
                            <p class="text-caption grey--text mb-0">Seleccione la ubicación para ver aranceles disponibles</p>
                        </div>
                      </div>
                   </v-col>
                   <v-col cols="12" md="6">
                      <v-select
                        v-model="sede"
                        :items="sedes"
                        item-text="sede.nombre"
                        item-value="sede.IDF"
                        placeholder="Selecciona la sede académica"
                        outlined
                        flat
                        persistent-hint
                        return-object
                        single-line
                        @change="loadData"
                        class="rounded-xl elite-input"
                        hide-details
                      ></v-select>
                   </v-col>
                </v-row>
             </v-card>
          </v-col>

          <!-- Concepts List -->
          <v-col cols="12">
            <div v-if="pagos.length > 0">
               <div class="d-flex align-center justify-space-between mb-6">
                  <h2 class="text-h5 font-weight-black prism-heading">Conceptos Disponibles</h2>
                  <v-chip class="font-weight-black px-4" color="primary" outlined>
                     {{ pagos.length }} ARANCELES
                  </v-chip>
               </div>

               <v-row>
                  <v-col v-for="(pagoData, pagoKey) in pagos" :key="pagoKey" cols="12" md="6" lg="4">
                     <v-card flat class="rounded-xl glass-card-interactive overflow-hidden h-full d-flex flex-column">
                        <div class="pa-6 flex-grow-1">
                           <div class="d-flex justify-space-between align-start mb-4">
                              <v-avatar size="48" color="primary lighten-5" class="elevation-0">
                                 <v-icon color="primary">mdi-credit-card-outline</v-icon>
                              </v-avatar>
                              <div class="text-right">
                                 <div class="text-h5 font-weight-black primary--text">${{ pagoData.Monto }}</div>
                                 <div class="text-tiny grey--text font-weight-bold uppercase">Monto Final</div>
                              </div>
                           </div>

                           <div class="text-subtitle-1 font-weight-black mb-1">{{ pagoData.Concepto }}</div>
                           <div class="text-caption grey--text mb-6">ID Trámite: #{{ pagoData.IDF }}</div>

                           <div class="elite-info-strip pa-4 rounded-xl mb-6">
                              <div class="d-flex justify-space-between mb-2">
                                 <span class="text-tiny grey--text font-weight-bold uppercase">Forma de Pago</span>
                                 <span class="text-tiny font-weight-black text--darken-2">{{ pagoData.forma_de_pago_data.Nombre }}</span>
                              </div>
                              <div class="d-flex justify-space-between">
                                 <span class="text-tiny grey--text font-weight-bold uppercase">Último Pago</span>
                                 <span class="text-tiny font-weight-black" :class="pagoData.ultimo_pago ? 'primary--text' : 'grey--text'">
                                    {{ pagoData.ultimo_pago || 'No registra' }}
                                 </span>
                              </div>
                           </div>

                           <v-btn
                            block
                            color="success"
                            large
                            depressed
                            class="rounded-xl font-weight-black shadow-glow-success mt-auto"
                            @click="createCobranza(pagoData.IDF)"
                          >
                            EFECTUAR PAGO
                            <v-icon right small>mdi-chevron-right</v-icon>
                          </v-btn>
                        </div>
                     </v-card>
                  </v-col>
               </v-row>
            </div>

            <!-- Empty State -->
            <div v-else-if="sede.value" class="text-center py-16 glass-card-light rounded-xl mt-10">
               <v-icon size="64" color="grey lighten-3">mdi-cash-remove</v-icon>
               <div class="grey--text mt-4 font-weight-medium">No se encontraron pagos pendientes en esta sede.</div>
            </div>
            <div v-else class="text-center py-16 glass-card-light rounded-xl mt-4">
               <v-icon size="64" color="primary lighten-4">mdi-map-search-outline</v-icon>
               <div class="grey--text mt-4 font-weight-medium">Por favor, seleccione una sede para visualizar los aranceles.</div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>
<script>
//  v-if="pagoData.pagadoAlumno == 0"
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "PaymentRegular",
  components: {
    // CardIeaApp,
    CardIeaAppMain, 
  },

  data: function() {
    return {
      title:"Efectuar pago",
      sede: {text:'', value:''},
      sedes:[],
      pagos:[],
      total:0,
      items:[],
      urlPay : ''
    }
  },

  methods: {
    async loadData() {
      console.log(this.sede)
      this.$API
        .get({
          url: "alumno-pagos-regulares?alumno="+this.user.IDStB+"&sede="+this.sede.sede.IDF,
          data: {},
        })
        .then((res) => {
          console.log(res)
          this.pagos = res;
        })
        .catch((err) => {
          console.log(err);
      });
    },

    colorText(pagoData) {
      let color = 'black';
      if(pagoData.block){
        color = '#888';
      }
      if(pagoData.pagado){
        color = 'green';
      }
      return {color:color}
    },

    canPay(pagoData) {
      return (!pagoData.block && !pagoData.pagado) ? true : false;
    },
    changeTotal(pagoData, index) {
      console.log(pagoData)
      pagoData.index = index;
      if(pagoData.check){
        this.total += pagoData.precioAPagar;
      }else{
        this.total -= pagoData.precioAPagar;
      }
      let selecteds = this.pagos.items.filter(d => {return d.check;})
      this.items = selecteds.map((value) => {return {id: value.IDStB, monto: value.precioAPagar, index:value.index }})
      console.log(this.items)
    },
    
    async createCobranza(id) {
      let dataSend = {
        alumno:this.user.IDStB
      };

      let url = "pago-concepto-regular/" + id;
     
      await this.$API
        .post({
          url: url,
          data: dataSend
        }).then((res) => {
          //Se crea la cobranza primero
          if(res.id){
            this.pay(res)
          }else{
            alert('Pago en revisión')
          }
          
        });
    },
    async pay(res) {
      await this.$API
      .post({
        url: "alumno-pagos-regulares-pay/" + res.id,
        data: res
      }).then((resUrl) => {
        location.href = resUrl
      });
    }
  },
  
  mounted() {
    this.$API
      .get({
        url: "alumno-sedes/" + this.user.IDStB,
        data: {},
      })
      .then((res) => {
        this.sedes = res;
      })
      .catch((err) => {
        console.log(err);
    });
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@700;900&display=swap");

.prism-elite-app {
  font-family: "Inter", sans-serif !important;
  background: radial-gradient(circle at 100% 100%, #0f172a 0%, #1e293b 100%);
  min-height: 100vh;
}

h1, h2, h3, .prism-heading, .text-overline {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: -0.5px;
}

.main-container-glass {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  min-height: 90vh;
}

.prism-top-bar { background: transparent; }
.prism-divider { border-color: rgba(0,0,0,0.05) !important; }

/* Elite Cards */
.glass-card-heavy {
  background: white;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(0,0,0,0.05) !important;
}

.glass-card-interactive {
  background: white;
  border: 1px solid #f1f5f9 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
}
.glass-card-interactive:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -15px rgba(26, 35, 126, 0.1) !important;
  border-color: #1a237e !important;
}

.glass-card-light {
   background: #f8fafc !important;
   border: 1px solid #e2e8f0 !important;
}

/* Elite Form Inputs */
.elite-input ::v-deep fieldset {
  border-color: rgba(0,0,0,0.08) !important;
  transition: border-color 0.3s;
}
.elite-input:hover ::v-deep fieldset {
  border-color: rgba(0,0,0,0.15) !important;
}
.elite-input.v-input--is-focused ::v-deep fieldset {
  border-color: #1a237e !important;
  border-width: 2px;
}

/* Info Strip */
.elite-info-strip {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

/* Icon Box */
.elite-icon-box {
  width: 50px;
  height: 50px;
  background: #f1f5f9;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.shadow-glow-success {
  box-shadow: 0 10px 20px -5px rgba(16, 185, 129, 0.3) !important;
}

.text-tiny { font-size: 0.75rem !important; }
.uppercase { text-transform: uppercase; }

.h-full { height: 100%; }

.transition-all {
  transition: all 0.3s ease;
}
</style>
